var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-date-picker',_vm._b({staticStyle:{"width":"100%"},on:{"change":_vm.handleDateChange},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}},'a-date-picker',_vm.instance,false))}
var staticRenderFns = []

export { render, staticRenderFns }